module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box fontFamily"
  }, [(true) ? _c('div', {
    staticClass: "index-header"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "242px",
      "width": "100%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../assets/images/bg-background.png"),
      "alt": "",
      "srcset": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-top": "3rem"
    }
  }, [_c('slidePics', {
    attrs: {
      "content": _vm.swiper,
      "top": 100
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card_show"
  }, [_c('div', {
    staticClass: "card_show_nav"
  }, [_vm._l((_vm.jingyingList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "card_show_nav_item",
      class: item.class,
      on: {
        "click": function($event) {
          return _vm.cardShowNavClickFun(item, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "card_show_nav_more",
    on: {
      "click": function($event) {
        return _vm.appearNavClickFun()
      }
    }
  }, [_vm._v("\n          更多  \n            ")])], 2), _vm._v(" "), (_vm.userListIndex == 0) ? _c('div', {
    staticClass: "card_show_content"
  }, _vm._l((_vm.aixing), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "card_show_content_item",
      on: {
        "click": function($event) {
          return _vm.goDetail(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "data-v-368263b2": "",
        "src": item.pic_url,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "card_show_content_item_name",
      attrs: {
        "data-v-368263b2": ""
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(item.title) + "\n\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "card_show_content_item_position",
      attrs: {
        "data-v-368263b2": ""
      }
    })])
  }), 0) : _c('div', {
    staticClass: "card_show_content"
  }, _vm._l((_vm.tuiguang), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "card_show_content_item",
      on: {
        "click": function($event) {
          return _vm.goDetail(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "data-v-368263b2": "",
        "src": item.pic_url,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "card_show_content_item_name",
      attrs: {
        "data-v-368263b2": ""
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(item.title) + "\n\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "card_show_content_item_position",
      attrs: {
        "data-v-368263b2": ""
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "more-box"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.news), function(row, i) {
    return _c('div', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.goDetail(row)
        }
      }
    }, [(row.pics.length == 0) ? _c('NewsItem1', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (row.pics.length == 1) ? _c('NewsItem2', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (false) ? _c('NewsItem3') : _vm._e(), _vm._v(" "), (row.pics.length > 1) ? _c('NewsItem4', {
      attrs: {
        "row": row
      }
    }) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "activity_list"
  }, [_c('div', {
    staticClass: "activity_list_nav"
  }, _vm._l((_vm.activitylistNavData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "activity_list_nav_item",
      class: item.class,
      on: {
        "click": function($event) {
          return _vm.activitylistNavClickFun(item, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), 0), _vm._v(" "), (_vm.cListIndex == 0) ? _c('div', {
    staticClass: "activity_list_content"
  }, _vm._l((_vm.notice), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "activityitem activity_list_item",
      on: {
        "click": function($event) {
          return _vm.goDetail(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.pic_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "activityitem_title"
    }, [_vm._v("\n            " + _vm._s(item.title) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "activityitem_others",
      attrs: {
        "data-v-62c25afd": ""
      }
    }, [_c('div', {
      staticClass: "activityitem_others_date",
      attrs: {
        "data-v-62c25afd": ""
      }
    }, [_vm._v("\n              " + _vm._s(item.create_time_str) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "activityitem_others_see",
      attrs: {
        "data-v-62c25afd": ""
      }
    }, [_vm._v("\n              " + _vm._s(item.views_count) + "阅读\n            ")])])])
  }), 0) : _c('div', {
    staticClass: "activity_list_content"
  }, _vm._l((_vm.course), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "activityitem activity_list_item",
      on: {
        "click": function($event) {
          return _vm.goCDetail(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.pic_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "activityitem_title"
    }, [_vm._v("\n            " + _vm._s(item.title) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "activityitem_others",
      attrs: {
        "data-v-62c25afd": ""
      }
    }, [_c('div', {
      staticClass: "activityitem_others_date",
      attrs: {
        "data-v-62c25afd": ""
      }
    }, [_vm._v("\n              " + _vm._s(item.create_time_str) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "activityitem_others_see",
      attrs: {
        "data-v-62c25afd": ""
      }
    }, [_vm._v("\n              " + _vm._s(item.views_count) + "阅读\n            ")])])])
  }), 0)]), _vm._v(" "), _c('TabBar', {
    attrs: {
      "show-tab-bar": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-header-face"
  }, [_c('img', {
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200527/user-1/20200527/5b8961a8b2c0e899a1a15702d52ac67a.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-search"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon-index-search.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "index-search-name"
  }, [_vm._v("搜索")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-header-right"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon-index-more.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-active"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "solid solid6"
  }), _vm._v(" "), _c('span', {
    staticClass: "more-title"
  }, [_vm._v("新闻中心")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "more-right"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5429ffcb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/H5Index.vue
// module id = 2393
// module chunks = 0